"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DesignServiceButton = void 0;
var HttpRequest_1 = require("../../Modules/HttpRequest");
var ApiEndpoints_1 = require("../../Configurations/ApiEndpoints");
var page_types_1 = __importDefault(require("../../helpers/page-types"));
var loading_indicator_1 = require("../mixins/loading-indicator");
var BasketCounter_1 = require("../Basket/BasketCounter");
var DesignServiceButton = /** @class */ (function () {
    function DesignServiceButton(successPopup, designServiceModal, modal) {
        DesignServiceButton.onButtonClick(successPopup, designServiceModal, modal);
    }
    DesignServiceButton.onButtonClick = function (successPopup, designServiceModal, modal) {
        var loadingIndicator = new loading_indicator_1.LoadingIndicator();
        loadingIndicator.showLoader();
        HttpRequest_1.Xhr.postFormData(ApiEndpoints_1.ApiEndpoints.ADD_TO_BASKET, DesignServiceButton.prepareData())
            .then(function (response) {
            successPopup.classList.remove('hide');
            modal.classList.add('smallmodal');
            designServiceModal.classList.add('hide');
            loadingIndicator.hideLoader();
            if (response.count) {
                var basketCounter = new BasketCounter_1.BasketCounter();
                basketCounter.update(response.count);
            }
        })
            .catch(function (xhrResponse) { return HttpRequest_1.Xhr.logXhrPromiseRejection(xhrResponse, 'DesignServiceButton on addToCart'); });
    };
    DesignServiceButton.prepareData = function () {
        return {
            product: this.DESIGN_CHANGE_SKU,
            quantity: 1,
            view: page_types_1.default.PDP,
        };
    };
    DesignServiceButton.DESIGN_CHANGE_SKU = 'KAM-IN-22';
    return DesignServiceButton;
}());
exports.DesignServiceButton = DesignServiceButton;
